// extracted by css-extract-rspack-plugin
module.exports =  {"contentBlock":"DeleteJobDialogAsAdmin__contentBlock___SHcQf"};